import clienteAxios from "../services/axios"
import { authHeader } from "../helpers/auth-header"

export const getNewAIBaseToken = (id) => {
	return clienteAxios.get(`/auth/${id}`, { headers: authHeader() })
}
